import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

/**
 * Updates the price-per-serving line when the product variant changes (same pattern as product-price).
 *
 * @extends {Component<{ output: HTMLElement }>}
 */
class PricePerServing extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const { output } = this.refs;
    const next = event.detail.data.html.querySelector(
      `price-per-serving[data-block-id="${this.dataset.blockId}"]`
    );
    if (!next || !output) return;

    const nextOutput = next.querySelector('[ref="output"]');
    if (!nextOutput) return;

    this.classList.toggle('hidden', next.classList.contains('hidden'));
    output.innerHTML = nextOutput.innerHTML;

    const nextId = nextOutput.getAttribute('id');
    if (nextId) {
      output.setAttribute('id', nextId);
    } else {
      output.removeAttribute('id');
    }
  };
}

if (!customElements.get('price-per-serving')) {
  customElements.define('price-per-serving', PricePerServing);
}
